import { useState, useCallback } from "react";
import Header from "../components/landing/Header";
import HeroLead from "../components/landing/HeroLead";
import TrustStrip from "../components/landing/TrustStrip";
import QuickQuizCTA from "../components/landing/QuickQuizCTA";
import HowItWorksShort from "../components/landing/HowItWorksShort";
import MicroProof from "../components/landing/MicroProof";
import FAQShort from "../components/landing/FAQShort";
import FinalCTA from "../components/landing/FinalCTA";
import Footer from "../components/landing/Footer";
import QuizDialog from "../components/landing/QuizDialog";
import MobileStickyCTA from "../components/landing/MobileStickyCTA";
import { PageProvider } from "../config/PageContext";

export default function LandingPage() {
  const [quizOpen, setQuizOpen] = useState(false);
  const openQuiz = useCallback(() => setQuizOpen(true), []);

  return (
    <PageProvider value="CENA">
      <div
        className="min-h-screen bg-white text-brand-ink font-body overflow-x-hidden"
        data-testid="landing-page"
      >
        <Header />
        <main>
          <HeroLead />
          <TrustStrip />
          <QuickQuizCTA onQuizClick={openQuiz} />
          <HowItWorksShort />
          <MicroProof />
          <FAQShort />
          <FinalCTA />
        </main>
        <Footer />
        <QuizDialog open={quizOpen} onOpenChange={setQuizOpen} />
        <MobileStickyCTA />
      </div>
    </PageProvider>
  );
}
